<form [formGroup]="form" class="container p-3">
    <div class="row mb-3">
        <div class="col">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Make</mat-label>
                <mat-select [disabled]="fixMake" formControlName="make_id" required>
                    <mat-option [value]="''">Select Make</mat-option>
                    <mat-option *ngFor="let make of makes$ | async" [value]="make.id">
                        {{ make.name }}
                    </mat-option>
                </mat-select>

                <mat-error
                    *ngIf="
                        form.controls.make_id.hasError('required') &&
                        (form.controls.make_id.dirty ||
                          form.controls.make_id.touched)
                      "
                >
                    Make is required.
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Model</mat-label>
                <mat-select formControlName="model_id" required>
                    <mat-option [value]="''">Select Model</mat-option>
                    <mat-option *ngFor="let model of models$ | async" [value]="model.id">
                        {{ model.name }}
                    </mat-option>
                </mat-select>

                <mat-error
                    *ngIf="
                        form.controls.model_id.hasError('required') &&
                        (form.controls.model_id.dirty ||
                          form.controls.model_id.touched)
                      "
                >
                    Model is required.
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Trim</mat-label>
                <mat-select formControlName="trim_id">
                    <mat-option [value]="''">Select Trim</mat-option>
                    <mat-option *ngFor="let trim of trims$ | async" [value]="trim.id">
                        {{ trim.name }}
                    </mat-option>
                </mat-select>

                <mat-error
                    *ngIf="
                        form.controls.trim_id.hasError('required') &&
                        (form.controls.trim_id.dirty ||
                          form.controls.trim_id.touched)
                      "
                >
                    Trim is required.
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="d-flex justify-content-center">
        <button mat-flat-button color="primary" (click)="onSearch()" class="submit-button mb-4">
            Submit
        </button>
    </div>

    <div class="row mt-3">
        <div class="col">
            <div class="d-flex">
                <div class="flex-grow-1" *ngIf="categories$ | async as categories">
                    <app-category-filter
                        *ngFor="let c of categories"
                        [ngClass]="{ 'd-none': !(products$ | async)?.length }"
                        [id]="c.category"
                        [name]="c.category"
                        [count]="c.count"
                        [isActive]="selectedCategory === c.category"
                        (selected)="onCategorySelected($event)"
                    ></app-category-filter>
                </div>
            </div>

            <div
                 class="products d-grid gap-md w-100 position-relative mb-3">
                <app-product-card *ngFor="let product of products$ | async" [product]="product" [showCart]="false" [showToggleButton]="false"></app-product-card>
            </div>

            <h3 class="text-center" *ngIf="(products$ | async)?.length === 0">No Products Found.</h3>

            <mat-paginator
                [ngClass]="{ 'd-none': !(products$ | async)?.length }"
                [length]="total"
                [pageSize]="15"
                [pageSizeOptions]="[5, 15, 25, 50, 100]"
                showFirstLastButtons
            ></mat-paginator>
        </div>
    </div>
</form>
